// Rendering parameters
export const FRAME_RATE = 30;

export const PLAY_VIDEO_TIMEOUT = 6000;
